import React, { useCallback } from 'react'
import { history } from 'store/store'
import AddIcon from '@material-ui/icons/Add'
import { Button } from 'components/buttons'
import { iconsCreator } from 'utils/iconsCreator'
import { format } from 'utils'

export const CreateButton = ({ canCreate, createButtonWidth, createButtonIcon,
  createDisabled, reasonForDisabling, createButtonTooltip, createButtonTitle,
  createButtonAction, metadata, localize, classes }) => {

  const { detailUrlFormat, detailUrlQueryParams, urls } = metadata
  const handleCreate = useCallback(() => {
    if (typeof createButtonAction === 'function') {
      createButtonAction()
    } else {
      const urlFormat = detailUrlFormat || `${urls.base}/{0}`
      history.push(format(urlFormat, 0) + (detailUrlQueryParams || ''))
    }
  }, [createButtonAction, detailUrlFormat, detailUrlQueryParams, urls.base])

  if (canCreate) {
    return <React.Fragment>
      <Button width={createButtonWidth} icon={createButtonIcon || <AddIcon />} disabled={createDisabled} color='primary' onClick={handleCreate} title={createButtonTooltip || localize('common.addTooltip')}>{createButtonTitle || localize('common.add')}</Button>
      {createDisabled && reasonForDisabling && <div className={classes.warning}>{iconsCreator('WarningIcon', { color: 'secondary'})} <span className={classes.text}>{reasonForDisabling}</span></div>}
    </React.Fragment>
  }
  return null
}
